import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Exchange, ExchangeRequest } from '../models/exchange.model';
import { BaseService } from './base.service';
import { CurrencyEnum } from '../models/enums/enums.model';

@Injectable({
  providedIn: 'root',
})
export class ExchangeService extends BaseService {

  constructor(private http: HttpClient) {
    super(http);
  }

  getAllExchanges(): Observable<Exchange[]> {
    return super.get<Exchange[]>('Exchange/FindAll')
    .pipe(
      map(exchanges =>
        exchanges.map(i => {
          const bidParts = i.bidValue.toString().split('.');
          const bid = bidParts[0];
          const bidDecimal = bidParts[1] ?? '';

          const offerParts = i.offerValue.toString().split('.');
          const offer = offerParts[0];
          const offerDecimal = offerParts[1] ?? '';

          const maxDecimalLength = Math.max(bidDecimal.length, offerDecimal.length, 2);

          const paddedBidDecimal = bidDecimal.padEnd(maxDecimalLength, '0');
          const paddedOfferDecimal = offerDecimal.padEnd(maxDecimalLength, '0');

          i.bid = bid;
          i.bidDecimal = paddedBidDecimal;
          i.offer = offer;
          i.offerDecimal = paddedOfferDecimal;

          i.percentage = Math.round((i.percentage + Number.EPSILON) * 100) / 100;

          // Map Currency
          i.currency = CurrencyEnum[i.currency as keyof typeof CurrencyEnum] ?? CurrencyEnum.Pesos;


          const specificDate = new Date(i.creationDate);
          const currentTime = new Date();

          // Calculate the time difference in milliseconds
          const timeDifference = currentTime.getTime() - specificDate.getTime();

          // Convert the time difference to minutes
          const minutesDifference = Math.floor(timeDifference / (1000 * 60));

          // Check if the time difference exceeds 30 minutes
          i.mustRefresh = minutesDifference > 30;

          return i;
        }
        )
      )
    );
  }

  saveExchange(exchange: ExchangeRequest): Observable<any> {
    return super.post('Exchange', exchange);
  }
}
